  
import { Vue, Component, Prop, Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import Quill from 'quill'
import VueQuillEditor from "vue-quill-editor";
import resizeImage from 'quill-image-resize-module' // 图片缩放组件引用
import { ImageDrop } from 'quill-image-drop-module'; // 图片拖动组件引用
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { toolBar } from "..";
Quill.register('modules/imageDrop', ImageDrop); // 注册
Quill.register('modules/resizeImage ', resizeImage ) // 注册 
Vue.use(VueQuillEditor);
@Component({
  name: "comForm"
})
export default class comForm extends BaseVue {
  @Prop({ default: false }) readonly!: Boolean;
  @Prop({ default: "" }) Token!: any; //token
  @Prop({ default: "" }) javacontent!: any; //token
  @Prop({ default: undefined }) height!: any;
  @Prop({ default: "/defaultTxt" }) Path!: any;
  @Prop({ default: "Insert text here ...." }) placeholder!: any; //token

  editorObj: any = null;
  eleId: any = "simplemde_ele" + this.NewGuid();
  content = "";
  editorOption:any = null
  @Watch("Token", { deep: false })
  updateToken(val) {
    this.loadTxtByToken();
  }
  @Watch("javacontent")
  javacontentChange(){
    this.content = this.javacontent
  }
  // 获取文本
  loadTxtByToken(){
    if (this.content=="加载中..."){
      this.content=""
    }
    if(this.Token=="" && this.javacontent!=""){
      this.content = this.javacontent
      return
    }
    
  }

  @Watch("readonly")
  readonlyChange(){
    this.editorOption = null
    this.$nextTick(()=>{
      this.editorOption = {
      placeholder:this.placeholder,
      modules: {
        imageDrop: true,      //图片拖拽
        imageResize: {          //放大缩小
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        toolbar:this.readonly?null:[  //只读情况无工具栏 by msh 2021-03-23
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
          ["link", "image", "video"]
        ],
        
      }
    }


    this.$nextTick(()=>{
      if(this.height){
        $("#"+this.eleId+" .ql-editor").css({ "min-height": "200px","height":this.height });
      }else{
        $("#"+this.eleId).css("height","100%")
        setTimeout(() => {
          let eleBoxH:any = $("#"+this.eleId).height()
          let toolbarH:any = $("#"+this.eleId+" .ql-toolbar").height()
          toolbarH = toolbarH?toolbarH+18:0
          console.log(toolbarH)
          $("#"+this.eleId+" .ql-editor").css({ "min-height": "200px","height":(eleBoxH-toolbarH)+"px" });
        }, 100);  
        (this.$refs["myQuillEditor"] as any).quill.enable(false);
        setTimeout(() => {
          (this.$refs["myQuillEditor"] as any).quill.enable(true); //2秒之后可以点击（聚焦）
        }, 1000);
      }
      this.loadTxtByToken()
      
    })
    })
  }


  mounted() { 
    this.editorOption = {
      placeholder:this.placeholder,
      modules: {
        imageDrop: true,      //图片拖拽
        imageResize: {          //放大缩小
          displayStyles: {
            backgroundColor: "black",
            border: "none",
            color: "white"
          },
          modules: ["Resize", "DisplaySize", "Toolbar"]
        },
        history: {
          delay: 1000,
          maxStack: 50,
          userOnly: false
        },
        toolbar:this.readonly?null:[  //只读情况无工具栏 by msh 2021-03-23
          ["bold", "italic", "underline", "strike"],
          ["blockquote", "code-block"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [{ font: [] }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["clean"],
          ["link", "image", "video"]
        ],
        
      }
    }
    this.$nextTick(()=>{
      if(this.height){
        $("#"+this.eleId+" .ql-editor").css({ "min-height": "200px","height":this.height });
      }else{
        $("#"+this.eleId).css("height","100%")
        setTimeout(() => {
          let eleBoxH:any = $("#"+this.eleId).height()
          let toolbarH:any = $("#"+this.eleId+" .ql-toolbar").height()
          toolbarH = toolbarH?toolbarH+18:0
          console.log(toolbarH)
          $("#"+this.eleId+" .ql-editor").css({ "min-height": "200px","height":(eleBoxH-toolbarH)+"px" });
        }, 100);  
        (this.$refs["myQuillEditor"] as any).quill.enable(false);
        setTimeout(() => {
          (this.$refs["myQuillEditor"] as any).quill.enable(true); //2秒之后可以点击（聚焦）
        }, 1000);
      }
      if (this.readonly) {
                $(".ql-container").css({
                    border: 'none'
                });
            }
      this.loadTxtByToken()
      
    })

    
  }
  onEditorBlur(editor) {
    // console.log('editor blur!', editor)
    // console.log(editor);
  }
  onEditorFocus(editor) {
    if(this.readonly){
      editor.enable(false); // 在获取焦点的时候禁用
    }    
    // console.log('editor focus!', editor)
  }
  onEditorReady(editor) {
    // console.log('editor ready!', editor)
  }
  onEditorChange(editor) {
    let  s = editor.text;
    let newString = s.substring(0,s.length - 1)
    this.$emit("change", editor.html);
    this.$emit("javaEdit", editor.html);
     this.$emit("javaEditNew", newString);
  }
 
  //校验空间内容是否为空
  checkedTextIsEmpty(){
    return this.content=='';
  }
}
